export default "__VITE_PUBLIC_ASSET__7a5cf12a__"